'use client'
import {useEffect, useState} from "react";
import cl from 'clsx'
import Image from 'next/image'
import { GoArrowUpRight } from "react-icons/go";
import Title from '@/ui/title'
import { scrollTo } from '@/utils/scrollTo';
import { Tooltip } from 'primereact/tooltip';
import styles from './styles.module.css'
import aboutImage from '@/public/images/about.png'
import profImage from '@/public/images/professional.png'
import testimonialImage from '@/public/images/testimonial.png'
import './styles.css'

export default function Offer({dict}) {
    const {tooltip} = dict.offer
    const [showTooltip, setShowTooltip] = useState(true);
    useEffect(() => {
        const handleResize = () => {
            setShowTooltip(window.innerWidth > 480);
        };

        handleResize(); // Initialize state
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const offers = [
        { 
            id: 1,
            title: dict.offer.card_1,
            image: aboutImage,
            destination: "idea",
            offset: showTooltip ? -140  : -10
        },
        { id: 2,
            title: dict.offer.card_2,
            image: profImage,
            destination: "discover",
            offset:  showTooltip ? 30 : -40
        },
        { 
            id: 3,
            title: dict.offer.card_3,
            image: testimonialImage,
            destination: "how",
            offset: -10
        },
    ]
    return (
        <section  id={"offer"} className={styles.offer}>
            <div className={'container'}>
                <Title
                    title={dict.offer.offer_you}
                    firstLine={dict.offer.title_1}
                    secondLine={dict.offer.title_2}
                />
                {showTooltip && <Tooltip target=".logo" mouseTrack mouseTrackLeft={10} />}
                <div className={styles.offer__content}>
                    {offers.map(({ id, title, image, destination, offset }) => (
                        <div
                            key={id}
                            className={cl(styles.offer__card, 'logo')}
                            data-pr-tooltip= {tooltip}
                            onClick={(event) => scrollTo(event, destination, offset)}
                        >
                            <Image
                                className={cl(styles.offer__card_image)}
                                src={image}
                                alt={'about the idea'}
                            />
                            <div className={cl(styles.offer__card_wrapper)} >
                                <h2 className={cl(styles.offer__card_title, styles.offer__card_underline)}>
                                    {title}
                                </h2>
                                <GoArrowUpRight className={styles.offer__arrow} />
                            </div>
                        </div>
                    )
                    )}
                </div>
            </div>
        </section>
    )
}
